import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { EnableFor } from '../../../containers/EnableForRole';
import { InputStatus } from '../../../models/error.model';
import { useWorkspacePermissions } from '../workspaces.permissions';

interface IRenameWorkspaceModalProps {
  showRenameWorkspace: boolean;
  renameWorkspaceName: string;
  renameWorkspaceNameStatus: InputStatus;
  toggleRenameWorkspace: () => void;
  onNameChange: (value: string) => void;
  onRenameSave: () => Promise<void>;
}

export const RenameWorkspaceModal = observer((props: IRenameWorkspaceModalProps): ReactElement => {
  const { t } = useTranslator();
  const permissions = useWorkspacePermissions();
  return (
    <S_Modal
      isOpen={props.showRenameWorkspace}
      toggle={props.toggleRenameWorkspace}
      headerText={t('rename_workspace')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.toggleRenameWorkspace}
          >
            {t('cancel')}
          </Button>
          <EnableFor hasPermission={permissions.canRenameWorkspace()}>
            <ButtonWithLoader
              loaderKey='rename-workspace-button'
              disabled={props.renameWorkspaceNameStatus.isValid !== true}
              onClick={props.onRenameSave}
            >
              {t('rename_workspace')}
            </ButtonWithLoader>
          </EnableFor>
        </>
      }
    >
      <ValidatedTextInput
        onPressEnter={() => {
          void props.onRenameSave;
        }}
        id='rename-workspace-input'
        labelText={t('new_name_for_workspace')}
        placeholder={t('workspace_type_new_workspace_name_here')}
        value={props.renameWorkspaceName}
        onChange={props.onNameChange}
        isValid={props.renameWorkspaceNameStatus.isValid}
        maxLength={200}
        feedbacks={props.renameWorkspaceNameStatus.errorCodes}
      />
    </S_Modal>
  );
});
